import { createFileRoute } from '@tanstack/react-router';
import { ImobilizadosPage, lerBuscaImobilizados } from '@/components/imobilizados';

export const Route = createFileRoute('/_app/cadastros/imobilizados')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaImobilizados(bruto),
  component: ImobilizadosRota,
});

function ImobilizadosRota() {
  return <ImobilizadosPage busca={Route.useSearch()} />;
}
